module.exports = __webpack_public_path__ + "static/media/thumbnail.d7bdd8f8.jpg";